import { render, staticRenderFns } from "./TradeType.vue?vue&type=template&id=d1d1d878&scoped=true&"
import script from "./TradeType.vue?vue&type=script&lang=js&"
export * from "./TradeType.vue?vue&type=script&lang=js&"
import style0 from "./TradeType.vue?vue&type=style&index=0&id=d1d1d878&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d1d878",
  null
  
)

export default component.exports